import React, { useState, useRef } from "react";
import { FaInstagram, FaLinkedinIn, FaTiktok, FaYoutube, FaFacebookF  } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./Footer.css";
import brandVideo from "../../assets/ISF-logo-video.mp4";
import FundraisingProgress from "./FundProgressFooter";

const BrandLogoVideo = () => {
  const videoRef = useRef(null);

  // Handle video end to restart playback
  const handleVideoEnd = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  return (
    <div className="brand-video-container">
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        onEnded={handleVideoEnd}
        className="brand-logo-video"
      >
        <source src={brandVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

const Footer = () => {
  // State for the subscribe form
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subscribeMessage, setSubscribeMessage] = useState("");

  // const [contactEmail, setContactEmail] = useState("");
  // const [message, setMessage] = useState("");
  // const [contactMessage, setContactMessage] = useState("");
  // const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle subscribe form submission
  const handleSubscribe = async (event) => {
    event.preventDefault();
    if (!email) {
      setSubscribeMessage("Please enter an email address.");
      return;
    }

    try {
      const response = await fetch(
        "https://impactstoriesfund.org/backend/public/api/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSubscribeMessage("Subscription successful!");
        setEmail(""); // Clear input after success
        console.log(email);
      } else {
        setSubscribeMessage(data.message || "Failed to subscribe.");
      }
    } catch (error) {
      setSubscribeMessage("An error occurred. Please try again.");
    }
  };

  // Handle contact form submission
  // const handleContactSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!name || !contactEmail || !message) {
  //     setContactMessage("Please fill in all fields.");
  //     return;
  //   }

  //   setIsSubmitting(true);

  //   try {
  //     const response = await fetch(
  //       "https://impactstoriesfund.org/backend/public/api/contact",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ name, email: contactEmail, message }),
  //       }
  //     );

  //     const data = await response.json();

  //     if (response.ok) {
  //       setContactMessage("Message sent successfully!");
  //       setName("");
  //       setContactEmail("");
  //       setMessage("");
  //     } else {
  //       setContactMessage(data.message || "Failed to send message.");
  //     }
  //   } catch (error) {
  //     setContactMessage("An error occurred. Please try again.");
  //   }

  //   setIsSubmitting(false);
  // };

  
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="row ">
          {/* Quick Links & Contact */}
          <div className="col-lg-3 quick-links-column">
            <h4 className="quick-link-title">Quick Links and Contact</h4>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/how-it-works">How It Works</a>
              </li>
              <li>
                <a href="/impact">Impact</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/faq">FAQs</a>
              </li>
              <li>
                <a href="/contact-us">Contact Us</a>
              </li>
              {/* <li>
                <a href="/donate">Donate</a>
              </li> */}
            </ul>
          </div>

          {/* Donation meter */}
          <div className="col-lg-5 pt-sm-3 align-middle video-column">
            <BrandLogoVideo />
          </div>

          {/* Contact Form */}
          <div className="col-lg-4 footer-column">

          <h4>Want to follow our progress?</h4>
          <p>We are happy to share updates with you.</p>
            <form
              className="footer-suscribe-form"
              onSubmit={handleSubscribe}
            >
              <div className="form-group">
                <label htmlFor="name">Your full name</label>
                <input
                  className="form-control mt-1"
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="form-group mt-3">
                <label htmlFor="email">Your email address</label>
                <input
                  className="form-control mt-1"
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              
              <button className="btn btn-warning mt-3" type="submit">Subscribe</button>
              {subscribeMessage && (
                <p className="subscribe-message text-color-white">
                  {subscribeMessage}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="socials">
            <a href="https://www.youtube.com/@ImpactStoriesFund" target="_blank" rel="noopener noreferrer"><span className="small-icon"><FaYoutube /></span></a>
            <a href="https://x.com/Impact_S_Fund" target="_blank" rel="noopener noreferrer"><span className="small-icon"><FaXTwitter /></span></a>
            <a href="https://instagram.com/impactstoriesfund" target="_blank" rel="noopener noreferrer"><span className="small-icon"><FaInstagram /></span></a>
            <a href="https://www.facebook.com/impact.stories.fund" target="_blank" rel="noopener noreferrer"><span className="small-icon"><FaFacebookF /></span></a>
            <a href="https://tiktok.com/@impact.stories.fund" target="_blank" rel="noopener noreferrer"><span className="small-icon"><FaTiktok /></span></a>
            <a href="https://www.linkedin.com/company/impact-stories-fund" target="_blank" rel="noopener noreferrer"><span className="small-icon text-center"><FaLinkedinIn /></span></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
